"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SuggestBox = _interopRequireDefault(require("01_core/components/materials/SuggestBox"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 会社選択部品
 * @prop {string} [value] - 選択している会社コード
 * @prop {function} onChange - 変更された会社のデータを受け取る関数
 * @prop {bool} isSetNone - 「選択してください」の表示有無の判定用の真偽値
 * シグネチャ：function(obj)) => void
 * obj：選択された会社 情報オブジェクト
 * { kaishaCd:string, kaishaNm:string }
 */
class SelectKaisha extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "BUMON_LV_1", '01');
    _defineProperty(this, "handleOnChange", value => {
      const selectSite = this.state.kaishaInfo.find(item => item.value === value);
      const kaishaCd = selectSite ? selectSite.value : '';
      const kaishaNm = selectSite ? selectSite.displayName : '';
      this.props.onChange({
        kaishaCd,
        kaishaNm
      });
    });
    this.state = {
      kaishaInfo: [],
      result: {
        kaishaCd: '',
        kaishaNm: ''
      }
    };
    props.callAPI(_APIs.KAISHA_SOSHIKI_SEARCH, {
      bumonLv: this.BUMON_LV_1
    }).then(json => {
      this.setState({
        kaishaInfo: json.data && json.data.selects && json.data.selects.lv1 ? json.data.selects.lv1 : []
      });
    });
  }
  render() {
    const {
      className,
      value,
      isSetNone
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      className: className,
      value: value,
      onChange: this.handleOnChange,
      items: this.state.kaishaInfo,
      setNone: isSetNone
    });
  }
}
SelectKaisha.propTypes = {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  isSetNone: _propTypes.default.bool.isRequired
};
const mapStateToProps = state => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _CallAPI.withCallAPI)((0, _reactIntl.injectIntl)(SelectKaisha)));